/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const FulfillmentTimeframe = {
  Immediate: "immediate",
  Other: "other",
  Over30Days: "over-30-days",
  PreOrder: "pre-order",
  RecurringSchedule: "recurring-schedule",
  ScheduledEvent: "scheduled-event",
  Within30Days: "within-30-days",
  Within7Days: "within-7-days",
} as const;
export type FulfillmentTimeframe = ClosedEnum<typeof FulfillmentTimeframe>;

/** @internal */
export const FulfillmentTimeframe$inboundSchema: z.ZodNativeEnum<
  typeof FulfillmentTimeframe
> = z.nativeEnum(FulfillmentTimeframe);
/** @internal */
export const FulfillmentTimeframe$outboundSchema: z.ZodNativeEnum<
  typeof FulfillmentTimeframe
> = FulfillmentTimeframe$inboundSchema;
